import { API_BASE_URL } from '../../../config/env'
import { fetchWithAuth } from '../../fetchWithAuth'

export const getNotifications = async ({ limit = 50 } = {}) => {
  try {
    const params = new URLSearchParams({
      limit: limit.toString(),
    })

    const response = await fetchWithAuth(`${API_BASE_URL}/notifications?${params.toString()}`)
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error fetching notifications:', error)
    throw error
  }
}

// "/notifications/unread-count",
export const getNotificationCount = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/notifications/unread-count`)

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }

    return await response.json()
  } catch (error) {
    console.error('Error fetching notification count:', error)
    throw error
  }
}

export const openNotification = async notificationId => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/notifications/${notificationId}/open`, {
      method: 'PATCH',
    })
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error opening notification:', error)
    throw error
  }
}

export const markNotificationsComplete = async ids => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/notifications/complete`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids }),
    })
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error marking notifications as complete:', error)
    throw error
  }
}

export const clearSelectedCompleteNotifications = async ids => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/notifications/complete/clear`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids }),
    })
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error clearing completed notifications:', error)
    throw error
  }
}

export const clearCompleteNotifications = async () => {
  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/notifications/complete/clear`, {
      method: 'DELETE',
    })
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      throw new Error(
        errorData.userFriendlyMessage ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      )
    }
    const data = await response.json()
    return data
  } catch (error) {
    console.error('Error clearing completed notifications:', error)
    throw error
  }
}